import { useTranslation } from 'next-i18next';
import { useFlags } from 'launchdarkly-react-client-sdk';
import Skeleton from 'react-loading-skeleton';

import { formatDateStr } from '@phoenix/core/frontend/shared/util/format/dates';
import { ProductDetails, ProductListItem } from '@phoenix/team-m/my-tool-shed/frontend/util/product/product.model';

import { LabelValue } from './label-value';

interface WarrantyEndDateProps {
  isLoading?: boolean;
  product: ProductListItem | ProductDetails;
}

export const WarrantyEndDate = ({ isLoading = false, product }: WarrantyEndDateProps) => {
  const { t } = useTranslation();
  const { 'warranty-info': warrantyInfoFlag } = useFlags();
  const { id, serialNumber, warrantyEndDate, warrantyExtensionDate } = product || {};

  const getTooltip = () => {
    if (!serialNumber || warrantyExtensionDate) {
      return undefined;
    }
    if (!warrantyEndDate) {
      return { id: `toolShed_warrantyDate_${id || serialNumber}`, body: t('toolShed_overview_listItem_tooltip_warranty') };
    }
    if (warrantyEndDate && warrantyInfoFlag) {
      return { id: `toolShed_warrantyDate_${id || serialNumber}`, body: t('toolShed_overview_listItem_tooltip_withoutExtension') };
    }
    return undefined;
  };

  return isLoading ? (
    <Skeleton />
  ) : (
    <LabelValue
      label={t('toolShed_overview_listItem_label_warrantyDate')}
      value={warrantyEndDate && formatDateStr(warrantyEndDate)}
      dataTestId="warrantyDate"
      isAlternativeBrand={!serialNumber}
      tooltip={getTooltip()}
    />
  );
};
